export const DOM = {
  body: document.querySelector('body'),
  $body: $('body'),
  $window: $(window),
  html: document.querySelector('html'),
  window,
};

export const CLASSES = {
  isActive: 'is-active',
  isVisible: 'is-visible',
  isHidden: 'is-hidden',
  isFixed: 'is-fixed',
  isOpen: 'is-open',
  isExpanded: 'is-expanded',
  modalOpened: 'is-modal-opened',
  isInvalid: 'is-invalid',
};
